import type { ContentGateRestriction } from "./types";

type CoockieNamesMap = {
  [key in NonNullable<ContentGateRestriction["type"]>]: (restriction?: ContentGateRestriction) => string | undefined;
};

export const COOKIE_NAMES: CoockieNamesMap = {
  AGE_VERIFIED: () => "isUserAgeVerified",
  PURPOSE: (restriction) => `isUserConsentProvided_${restriction?.purposeId ?? ""}`,
  DEVICE_REGISTRATION: () => "isUserDeviceRegistered",
  LOGGED_IN: () => "isUserLoggedIn",
};
